import { FC, ReactElement, useEffect } from 'react'
import FullBlock from '../../components/fullBlock'
import { useAuth } from '../../hooks/auth'
import { RoutesEnum } from '../../utils/routesEnum'

const Logout: FC = (): ReactElement => {
  const { logout } = useAuth()

  useEffect(() => {
    logout().finally(() => {
      location.href = RoutesEnum.HOME
    })
  }, [logout, logout])

  return (
    <FullBlock>
      Saindo...
    </FullBlock>
  )
}

export default Logout
